import { Navigate, Outlet } from 'react-router-dom';

export default function RequirePartnerToken() {
  const token = localStorage.getItem('partner_token');
  if (!token) return <Navigate to="/partner/login" replace />;
  return <Outlet />;
}
